<div class="p-l-3 p-r-4 p-r-2-s p-b-5">
  <button type="button"
    class="flex flex-justify-between cursor-pointer p-t-5 w-12"
    [zippyToggle]="zippyId">
    <span class="flex-grow w-12 flex flex-stretch p1">
      <span [zippyName]="zippyId"
        zippyClass="s1 !p1">
        {{label}}
      </span><span class="flex-grow pos-relative m-r-3">
      @if (selection) {
        <span class="p-l-2 fill overflow-hidden no-wrap col-12 left"
          [zippyName]="zippyId"
          zippyClass="ng-hide">
          <span>|</span><span class="p-l-2">{{selection}}</span>
          <span class="selection-gradient pos-absolute top-0 bottom-0 right-0"></span>
        </span>
      }
    </span>

  </span>
  <span lineHeightBy="p1">
    <i [zippyName]="zippyId"
       class="icon-chevron-right _zippy-class"
       zippyClass="_rotate"></i>
  </span>
</button>


<div class="hide-up-container">
  <div class="ng-hide ng-hide-animate hide-up _hide-up-150"
    [zippyState]="isDefault"
    [zippy]="zippyId">
    <ng-content></ng-content>
  </div>
</div>
</div>
